import { PUNCTUATION } from '../../../../utils/constants/notation';

/**
 * "95028 Hof, Germany". Missing parts are dropped; n/a when all are missing.
 * The country arrives as a full name from the backend.
 */
export const formatBankLocation = ({ postcode, city, country_name: countryName } = {}) => {
  const place = [postcode, city].filter(Boolean).join(PUNCTUATION.SPACE);
  const location = [place, countryName].filter(Boolean).join(`${PUNCTUATION.COMMA} `);
  return location || PUNCTUATION.EMPTY_VALUE;
};
